// extracted by mini-css-extract-plugin
export default {"loader":"skeleton-loader_loader__+Jxdm","SkeletonLoaderShine":"skeleton-loader_SkeletonLoaderShine__s1l7-"};